import Dashboard from './containers/Dashboard';
import requireAuth from '../../../utils/requireAuth';

export const dashboardRoutes = [
    {
        path: '/technical/planner-tracker/dashboard',
        component: requireAuth(Dashboard),
        key: 'SpartaPlannerDashboard',
    },
];
